import { render, staticRenderFns } from "./DetailsComponent.vue?vue&type=template&id=8a2e116e"
import script from "./DetailsComponent.vue?vue&type=script&lang=js"
export * from "./DetailsComponent.vue?vue&type=script&lang=js"
import style0 from "./DetailsComponent.vue?vue&type=style&index=0&id=8a2e116e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports